var IntercomManager = /** @class */ (function () {
    function IntercomManager() {
    }
    Object.defineProperty(IntercomManager.prototype, "intercom", {
        get: function () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return window.Intercom;
        },
        enumerable: false,
        configurable: true
    });
    IntercomManager.prototype.createInstaller = function (credentials) {
        if (!credentials.app_id) {
            throw new Error('IntercomManager: App Id is required to connect to Intercom');
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', credentials);
        }
        else {
            var d_1 = document;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var i_1 = function () {
                i_1.c(arguments);
            };
            i_1.q = [];
            i_1.c = function (args) {
                i_1.q.push(args);
            };
            w.Intercom = i_1;
            var insertIntercomScript = function () {
                var s = d_1.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = "https://widget.intercom.io/widget/" + credentials.app_id;
                var x = d_1.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            insertIntercomScript();
        }
        return this;
    };
    IntercomManager.prototype.boot = function (credentials) {
        this.intercom('boot', credentials);
    };
    IntercomManager.prototype.shutdown = function () {
        this.intercom('shutdown');
    };
    IntercomManager.prototype.newMessage = function (prepopulatedMessage) {
        this.intercom('showNewMessage', prepopulatedMessage);
    };
    return IntercomManager;
}());
export { IntercomManager };
